export const ERROR_LIST = {
	// Server Errors (From Reach API Docs)
	RateOfferNotFound: "The Exchange Rate offer was not found or has expired. Please refresh the page and try again.",
	CurrencyNotFound: "The ConsumerCurrency did not correspond to a supported Reach currency.",
	CurrencyMismatch: "The ConsumerCurrency specified in the request did not match the Currency associated with the specified Reach rate offer.",
	EmailAddressInvalid: "The billing email was either invalid or not supplied when required.",
	PaymentMethodUnsupported: "The PaymentMethod is either not supported by Reach or the merchant has not been approved to use it.",
	CardNameInvalid: "The Name in the card details was not valid.",
	CardNumberInvalid: "The Number in the card details was not valid for the specified payment method.",
	CardYearInvalid: "The Year in the card details was not valid.",
	CardMonthInvalid: "The Month in the card details was not valid.",
	CardExpired: "The specified payment card has expired.",
	CardVerificationCodeInvalid: "The VerificationCode in the card details was not valid.",
	PostalCodeInvalid: "The consumer PostalCode was either invalid or not supplied when required.",
	CountryInvalid: "Country was either invalid or not supplied when required.",
	CurrencyInvalid: "Currency selection is required.",
	AmountInvalid: "An invalid / missing Invoice amount was provided.",
	AmountLimitExceeded: "The request contains an amount that exceeds the amount that Reach is willing to transact in a single order for the merchant.",
	PaymentAuthorizationFailed: "The payment processing provider, or an intermediary, refused to authorize the payment despite the details being syntactically correct. For example, the payment processor’s fraud checks may have failed or the payment processor may have been unable to validate authentication.",
	ContractNotFound: "The specified ContractId is not associated with the requesting Merchant.",
	ContractClosed: "The specified ContractId is closed and cannot be used to begin new orders.",
	InstalmentsInvalid: "A number was specified for Instalments which is not between 2 and 12.",
	InstalmentsNotAvailable: "Instalments were specified, but are not available for the specified card.",
	BirthDateInvalid: "The consumer birth date was either invalid or not supplied when required.",
	NationalIdentifierInvalid: "The billing national identifier was either invalid or not supplied when required.",
	PhoneInvalid: "The billing phone was either invalid or not supplied when required.",
	RegionInvalid: "The billing region was either invalid or not supplied when required.",
	SpotTradeInvalid: "The merchant is not configured to perform a spot trade.",
	CaptureInvalid: "The specified value of Capture is not valid for the payment method.",
	IssuerInvalid: "The specified IssuerId is not recognized by the WithReach system.",
	ConsumerTotalInvalid: "The ConsumerTotal is not correct.",
	ContractCurrencyMismatch: "The Currency used in this request did not match the currency used to open the specified contract.",
	ContractPaymentMethodMismatch: "The PaymentMethod used in this request did not match the payment method used to open the specified contract.",
	ContractIssuerMismatch: "The Issuer used in this request did not match the issuer used to open the specified contract.",
	ConsumerInvalid: "The billing information provided is invalid.",
	ConsigneeInvalid: "The specified Consignee is invalid.",
	PaymentAuthorizationFailed: "The payment could not be authorized after the consumer returned from the external site.",
	PaymentAuthenticationCancelled: "The consumer cancelled payment on the external site.",
	AlreadyCancelled: "The order was cancelled before the consumer completed authentication.",
	PaymentFailed: "The payment was authorized but could not be captured.",
	ReferenceIdInvalid: "An invalid Invoice ID was provided. Please contact the merchant / administrator.",

	// Custom App Errors
	// Invoice Step
	MissingInvoiceId: "Please enter an Invoice ID.",
	InvalidInvoiceId: "Invoice ID is invalid or contains spaces.",
	NoPaymentMethods: "No Payment Methods found. Please try again later.",
	NoExchangeRates: "No Currency Rates found. Please try again later.",

	// Billing step
	InvalidBillingName: "The name you entered was invalid or missing.",
	InvalidBillingAddress: "The address you entered was invalid or missing.",
	InvalidEmailAddress: "The email address you entered was invalid or missing.",
	InvalidBillingCity: "The city you entered was invalid or missing.",
	InvalidBillingRegion: "The region you entered was invalid or missing.",
	InvalidBillingCountry: "The Country you selected was invalid or missing.",
	InvalidBillingPostalCode: "The postal code you entered was invalid or missing.",
	InvalidBillingPhoneNumber: "The phone number you entered was invalid or missing.",
	InvalidBillingNationalIdentifier: "The national Identification number you entered was invalid or missing.",
	InvalidBillingBirthDate: "The birth date you provided was invalid or missing.",

	// Payment Step
	MissingCreditCardType: "Please select a credit card type to continue!",
	MissingPaymentMethod: "Please select a payment method to continue!",
	MissingFinancialInstitution: "Please select an financial institution to continue.",
	InvalidCardholderName: "The cardholder name you entered was invalid or missing.",
	StashFailure: "Your card data was found to be invalid, or the server encountered an unidenified error. Please try again later",
	InvalidCardNumber: "The provided card number was invalid. Please try again.",
	InvalidCardSecurityCode: "The provided security code was invalid. Please try again.",
	InvalidCardExpiry: "The provided Expiry Date was invalid. Please try again.",
	CardPostExpiry: "The provided card has already expired. Please try a different card.",

	// Review Step
	AcceptTerms: "Please accept the terms and conditions to continue.",
	SecondaryAuthFailed: "Secondary authorization failed! Please try again.",

	// General Errors
	ServerError: "An error occurred while receiving response from the server. Please try again later.",
	OrderNotFound: "The order or payment you are trying to reference could not be found.",
	UnknownError: "An unknown error occurred! Please contact an administrator.",
	ClientNotFound: "There was an error loading client data",
	GenericError: "An Error occurred! Please try again later.",
	FingerprintError: "An error occurred while trying to identify your browser.",
	IncorrectMerchantConfig: "Merchant configuration is missing or incorrect.",

	// Auto-loading data
	BadUrlData: "The URL was incorrect or invalid. Please check the link and try again.",
	BadUrlMissingCountry: "The URL data was malformed or invalid. We could not identify your Country.",
	BadUrlMissingAmount: "The URL data was malformed or invalid. We could not identify your Payment Amount.",
	BadUrlMissingInvoice: "The URL data was malformed or invalid. We could not identify your Payment Reference.",
	InvoiceLinkHasExpired: "Your payment link has expired. Please contact the Merchant.",

	// Fallback string
	NotFound: "Error not Found!"
};
